import { useState, useCallback, useEffect, useRef } from 'react';
import type { MessageState } from '../types';

export function useSettingsMessage() {
  const [message, setMessage] = useState<MessageState | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showMessage = useCallback((type: MessageState['type'], text: string) => {
    // Clear any existing timer to prevent stale dismissals
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
    }
    setMessage({ type, text });
    timerRef.current = setTimeout(() => {
      setMessage(null);
      timerRef.current = null;
    }, 5000);
  }, []);

  // Cleanup timer on unmount to fix the original timer leak bug
  useEffect(() => {
    return () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return { message, showMessage };
}
